/**
  * @ngdoc component
  * @name common.component:itxLogin
  *  
  * @param {String} email Description 
  * @param {Object} data Description 
  * @param {Object} guestTokens Description 
  * @param {Function} onLogin Function emmited when log in was successfull 
  * @param {Function} onValidationError Description
  *
  * @description
  * Login component
  * 
*/
(function () {

    'use strict';

    var ItxLoginCmp = {
        bindings: {
            email: '=userLogin',
            data: '<',
            guestTokens:'<',
            onLogin: '&',
            onValidationError: '&'
        },
        require: {
            'userAccessCtrl': '?^itxUserAccess'
        },
        controller: ItxLoginCmpCtrl,
        controllerAs: 'loginCtrl',
        templateUrl: ['$element', '$attrs', function ($element, $attrs) {
            return $attrs.template || 'login.component.html';
        }]
    };

    ItxLoginCmpCtrl.$inject = [
        '$rootScope',
        'ItxErrorMessagesFct',
        'ItxShopCartFct',
        'ItxLoaderFct',
        'ngDialog',
        'ItxScreenSizeSvc',
        'imAccessService',
        'imDispatcherService',
        'ItxLoginSvc',
        'ItxTranslateSvc',
        'NostromoSvc',
        'CountryService',
        'DUTTI_CONS',
        'NavigationService',
        '$timeout',
        'acceptanceService'
    ];

    function ItxLoginCmpCtrl (
        $rootScope,
        ItxErrorMessagesFct,
        ItxShopCartFct,
        ItxLoaderFct,
        ngDialog,
        ItxScreenSizeSvc,
        imAccessService,
        imDispatcherService,
        ItxLoginSvc,
        ItxTranslateSvc,
        NostromoSvc,
        CountryService,
        DUTTI_CONS,
        NavigationService,
        $timeout,
        acceptanceService
    ) {
        var _this = this;

        _this.previousRouteRedirect = false;

        _this.loginRequestActive = false;

        _this.phoneLoginEnabled = false;
        _this.model = {};

        inditex.onReady(function () {
            _this.rememberMeAllowed = joyr.user.utils.rememberMeAllowed();
            setTimeout(() => {
                _this.callCenterMsg = ItxTranslateSvc.translateCms('login.callCenter', inditex.iStoreJSON.details.supportPhone, inditex.iStoreJSON.details.supportEmail);    
            }, 500);
            
        });

        _this.$onInit = function () {
            _this.previousRouteRedirect = inditex.getLocalStorage('previous_route_redirect');
            inditex.removeLocalStorage('previous_route_redirect');

            ItxLoaderFct.show();

            inditex.getXconfiguracionValue('PHONE_REGISTER_LOGIN_ENABLED', function (status, value) {
                ItxLoaderFct.hide();
                if (value == 1) {
                    _this.phoneLoginEnabled = true;
                }
                $timeout();
            });

            if (inditex.iStoreJSON) {
                _this.countryCode = inditex.iStoreJSON.countryCode;
            }

            if(document.location.href.indexOf('checkout-auth')>-1 || document.location.href.indexOf('my-account.html#/login')>-1){
                NostromoSvc.login();
            }

            _this.loginModel = null;
            _this.loginForm = null;
            _this.totalTries = 0;
            _this.isMobileSize = ItxScreenSizeSvc.is('xs') || ItxScreenSizeSvc.is('sm');
            _this.isDesktopSize = ItxScreenSizeSvc.is('md') || ItxScreenSizeSvc.is('lg');

            _this.isWW = CountryService.is(DUTTI_CONS.stores.DuttiWW);
            _this.isKorea = CountryService.is(DUTTI_CONS.stores.DuttiKR);

            _this.myAccountLogin = false;

            if(document.location.href.indexOf('my-account')>-1){
                _this.myAccountLogin = true;
            }
        };

        _this.showRecover = function () {
            ngDialog.open({
                template: 'user-access-dialog-wrapper.tpl',
                className: 'new-modal ma-modal-md ma-modal-macro recover-dialog ngdialog-theme-plain',
                showClose: true,
                bindToController: true,
                data: 'recover-password',
                preCloseCallback: function () {
                    imAccessService.triggerView('login');
                }
            });
            // Hotjar user behavior analytics
            if(typeof hj != 'undefined'){
                hj('tagRecording', ['passwordrecovery']);
            }
        };

        _this.login = function () {
            // No permite volver a solicitar login si una petición de login no ha terminado
            if(_this.loginRequestActive) {
                return;
            }

            _this.totalTries ++;

            _this.loginForm.$setSubmitted();

            if (_this.loginForm.$valid) {
                let logon = false, password = _this.loginModel.password, options = {};

                if(_this.phoneLoginEnabled){
                    logon = _this.logon;
                    options.phoneLoginEnabled = true;
                } else {
                    logon = _this.email;
                }

                if (_this.loginModel.rememberMe) {
                    options.rememberMe = true;
                }
                if (_this.loginModel.phone && _this.loginModel.code) {
                    options.phone = _this.loginModel.phone;
                    options.code = _this.loginModel.code;
                }                
                if (inditex.iPage === 'ItxCheckoutAuthPage' || inditex.iPage === 'ItxOrderConfirmationPage' || inditex.iPage === 'ItxGuestAccountPage') {
                    options.emailGuestUser = true;
                }
                if(_this.data && _this.data.guestToken && _this.data.orderId){
                    options.guestToken = _this.data.guestToken;
                    options.orderId = _this.data.orderId;
                }
                if (_this.userAccessCtrl) {
                    options.preselectedFields = _this.userAccessCtrl.preselectedFields;
                }
                if (logon && password) {
                    ItxLoaderFct.show();
                    if(_this.guestTokens){
                        options.guestTokens = _this.guestTokens;
                    }

                    _this.loginRequestActive = true;

                    ItxLoginSvc.login(logon, password, options)
                        .then(function () {
                            if( _this.isChina() ){
                                acceptanceService.consent( 'LOGIN', ["transferenciaforzosa", "datossensibles"], logon );
                            }
                            _this.loginRequestActive = false;
                            _this.previousState = window.previousState;
                            NostromoSvc.loginDone();
                            if (_this.myAccountLogin) {
                                if (_this.previousState) {
                                    window.location.href = location.origin + location.pathname + _this.previousState;
                                } else {
                                    if (_this.previousRouteRedirect) {
                                        window.location.href = _this.previousRouteRedirect;
                                    } else {
                                        window.location.href = location.origin + location.pathname + '#/menu';
                                    }
                                }
                            }
                        if (_this.userAccessCtrl) {
                            _this.userAccessCtrl.closeDialog();
                        }
                        if (_this.onLogin) {

                            _this.onLogin();
                        }
                        
                        // IMAnalytics trigger sesion_permanente
                        if (options.rememberMe) {
                            imAccessService.createEvent('acceso_login', 'sesion_permanente');
                        }
                        // IMAnalytics  trigger Analytics Event
                        imAccessService.eventSessionOK('acceso_login', 'iniciar_sesion_ok');

                        // IMAnalytics Llamada al servicio que lanza el evento del pageview.
                        imDispatcherService.sortEvent('pageview');

                        // Hotjar user behavior analytics
                        if(NavigationService.isHomePage()){
                            if(typeof hj != 'undefined'){
                                hj('tagRecording', ['iniciar_sesion']);
                            }
                        }
                    })
                    .catch(function (error) {
                        
                        _this.loginRequestActive = false;

                        if( error && error.errorKey && error.errorKey.indexOf('_ERR_PHONE_NO_VALIDATE') > -1){
                            _this.showValidation = true;
                        }
                        else if(error && error.errorKey && error.errorKey.indexOf('_ERR_INVALID_PARAM') > -1 && _this.loginForm.code){
                            _this.loginForm.code.$setValidity('invalidcode',false);
                         }
                        else{
                            ItxErrorMessagesFct.add(error, 'userAccessCtrl', 'ERROR');
                        }

                        /**
                         * IMAnalytics trigger event server error
                         */
                        imAccessService.createServer('acceso_login', _this.loginForm, error);
                    })
                    .finally(function () {
                        _this.loginRequestActive = false;
                        ItxLoaderFct.hide();
                    });
                }
            }
            else {
                // IManalytics trigger errorForm
                imAccessService.createForm('acceso_login', _this.loginForm);
            }
        };

        _this.naverLogin = function() {
            _this.userAccessCtrl.closeDialog();
            // Remove base tag element with 'baseHrefjs' id temporarily during Naver login process 
            _this.elem = document.getElementById('baseHrefjs');
            if(_this.elem){
                _this.elem.parentNode.removeChild(_this.elem);
            }
        };

        _this.$onDestroy = function () {
            ItxErrorMessagesFct.reset('userAccessCtrl', 'ERROR');
        };

        _this.setPhone = function(data){
            _this.loginModel.code = data.code;
            _this.loginModel.phone = data.phone;
        };

        _this.isSendEnabled = function() {
            if(_this.isChina()){
                return !_this.model.privacyPolicyAccepted ||
                !( _this.model.sensitive_data && _this.model.transfer_data );
            }else{
                return false;
            }
        }

        _this.isChina = function(){
            return inditex.iCountryCode === 'CN';
        }

        _this.clickSecondaryTemplate = function( form ){
            _this.model.privacyPolicyAccepted = form.privacyPolicyAccepted.$viewValue;
            _this.model.transfer_data = form.transfer_data.$viewValue;
            _this.model.sensitive_data = form.sensitive_data.$viewValue;
            _this.isSendEnabled();
        }
    }

    angular.module('itxApp.common')
        .component('itxLogin', ItxLoginCmp);

})();